import { Injectable } from '@angular/core';

@Injectable()
export class DesktopGlobalStateService {

    // var to hold desktop global state
    // indicates which user data has been fetched from server 
    // at least once in this app launch
    private _state:{
        entitlements: boolean,
        spaces: boolean,
        bundles: boolean,
        ebookUserData: Array<string>,
        LOStatements: boolean
    }

    static STATE_PROPS = {
        ENTITLEMENTS: "entitlements",
        SPACES: "spaces",
        BUNDLES: "bundles",
        EBOOK_USER_DATA: "ebookUserData",
        LO_STATEMENTS: 'LOStatements'
    }

    constructor(){
        this._state = {
            entitlements: false,
            spaces: false,
            bundles: false,
            ebookUserData: [],
            LOStatements: false
        }
    }

    /**
     * 
     * @param propType : property name
     * @param value : string in case of EBOOK_USER_DATA else boolean
     */
    updateState(propType, value?){
        if(propType == DesktopGlobalStateService.STATE_PROPS.EBOOK_USER_DATA){
            this._state.ebookUserData.push(value)
        }else{
            if(value == undefined) value = true;
            this._state[propType] = value;
        }
    }

    /**
     * 
     * @param propName : It has to be a value from STATE_PROPS
     * @returns array of ebookCodes for EBOOK_USER_DATA else boolean
     */
    getState(options:any = {}){
        if(options.propName){
            if(options.propName == DesktopGlobalStateService.STATE_PROPS.EBOOK_USER_DATA && options.ebookCode){
                return (this._state[DesktopGlobalStateService.STATE_PROPS.EBOOK_USER_DATA].indexOf(options.ebookCode) >= 0);
            }
            return this._state[options.propName];
        }else{
            return this._state;
        }
    }

    /**
     * Method used to reset global state
     * This would be called on user logout
     */
    resetState(){
        this._state = {
            entitlements: false,
            spaces: false,
            bundles: false,
            ebookUserData: [],
            LOStatements: false
        }
    }
}